import React, { Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';
import bot_icon from './../../assets/bot_icon.png';
const styles = `
    .ql-toolbar {
       border: 0px!important;
       background: rgb(233, 238, 244);
  border-radius: 20px;
    }

    .ql-editor {
      min-height: 20px !important;
    max-height: 300px !important;
  overflow-y: auto;
    }

    .ql-container{
      border: 0px!important;
      background: rgb(233, 238, 244);
    } 
`;

export default function Logs({ content, avatar, agentIcon }) {
    const [messageContent, setMessageContent] = React.useState([]);
    React.useEffect(() => {
        try {
            console.log('content', typeof content, content);
            if (content.length > 0) {
                let lst = [];
                content.forEach(item => {
                    lst.push({ type: 'user', content: item['user'] });
                    lst.push({ type: 'bot', content: item['bot'] });
                });
                setMessageContent(lst);

            } else {
                setMessageContent([{ type: 'user', content: content['user'] }, { type: 'bot', content: content['bot'] }]);
            }
        } catch (e) {
            setMessageContent([{ type: 'user', content: content['user'] }, { type: 'bot', content: content['bot'] }]);
        }
    }, [content]);

    const renderMarkdown = (text) => {
        if (!text || typeof text !== 'string') return null;
        let content = text
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&amp;/g, '&')
            .replace(/【[^】]*?†([^】\s]+)】/g, '$1')
            .replace(/【[^】]*?†([^\s【】*]+)\*\*/g, '$1')
            .replace(/\b\d+:\d+†([^\s【】]+)/g, '$1')
            .replace(/[【】]/g, '')
            .replace(/\*\*([^*\n>]+)\*\*/g, '%%BOLD%%$1%%BOLD%%')
            .replace(/\*\*/g, '')
            .replace(/%%BOLD%%([^%]+)%%BOLD%%/g, '**$1**')
            .replace(/^([^(\n]*)(\s*)\)(\s*)$/gm, '$1')
            .trim();
        return (
            <ReactMarkdown
                remarkPlugins={[remarkGfm, remarkBreaks]}
                components={{
                    a: ({ href, children }) => (
                        <a href={href} target="_blank" rel="noopener noreferrer">
                            {children}
                        </a>
                    ),
                }}
            >
                {content}
            </ReactMarkdown>
        );
    };

    return (<Card
        className="cardHeightActive"
        style={{
            //overflow: 'scroll',
            backgroundColor: '#fff',
        }}
    >
        
        <style>{styles}</style>
        <CardBody style={{ height: `100%`, overflowY: 'scroll' }}>
            {messageContent.length > 0 && messageContent.map((item, index) => (
                <Fragment key={index}>
                    {item.type === 'user' ?
                        <div
                            className={`scroll mail-div 
                 'divHeight'
                    }`}
                        >
                            <Fragment>
                                <div className="tawk-avatar tawk-message-profile tawk-flex-none">
                                    <div className="tawk-avatar-image">
                                        <i className="iconsminds-female-2"></i>
                                    </div>
                                </div>
                            </Fragment>
                            <Card
                                className={`tawk-message-group-roght
                             tawk-flex-1 d-inline-block mb-3 conversationMessage`}
                                style={{ width: '90%' }}
                            >
                                {/* <div
                            className="position-absolute pt-1 pr-2 r-0"
                            style={{ top: '0' }}
                        >
                            <span className="text-extra-small">
                                {moment(item.time).format('MMM DD, YYYY h:mm a')}
                            </span>
                        </div> */}

                                <CardBody>
                                    <div className="chat-text-left">
                                        <div className="mb-0">
                                            {renderMarkdown(item.content)}
                                        </div>
                                        <br />
                                    </div>
                                </CardBody>
                            </Card>
                        </div> :
                        <div
                            className={`scroll mail-div 
                 'divHeight'
                    }`}
                        >
                            <Card
                                className={`tawk-message-group-left
                             tawk-flex-1 d-inline-block mb-3 conversationMessage`}
                                style={{ width: '90%' }}
                            >
                                <CardBody>
                                    <div className="chat-text-right">
                                        <div className="mb-0">
                                            {renderMarkdown(item.content.replace('<p>', '').replace('</p>', '').replace(/<br\s*\/?>/gi, '\n') ?? '')}
                                        </div>
                                        <br />
                                    </div>
                                </CardBody>
                            </Card>
                            <div className="tawk-avatar tawk-message-profile tawk-flex-none">
                                <div className="tawk-avatar-image">
                                    <img
                                        src={bot_icon}
                                        alt="Agent profile image"
                                    />
                                </div>
                            </div>
                        </div>}
                </Fragment>))}
        </CardBody >
    </Card >);
}